import axios from "axios";
import initializeAxios from "../util/Axios";

class StaffService {
    constructor() {
        initializeAxios();
    }

    /**
     * Get staff list for logged-in SchoolAdmin's school
     */
    async getStaff(
        searchTerm = "",
        pageIndex = 0,
        pageSize = 10
    ) {
        const response = await axios.get("/api/staff", {
            params: {
                searchTerm,
                pageIndex,
                pageSize
            }
        });

        return response.data;
    }

    /**
     * Create new staff member
     */
    async createStaff(data) {
        const response = await axios.post("/api/staff/create", data);
        return response.data;
    }

    /**
     * Update staff member
     */
    async updateStaff(staffId, data) {
        const response = await axios.put("/api/staff/update", {
            staffId,
            data
        });

        return response.data;
    }

    /**
     * Delete staff member (soft delete)
     */
    async deleteStaff(staffId) {
        const response = await axios.delete(`/api/staff/${staffId}`);
        return response.data;
    }

    /**
     * Get staff details (reuse users API if shared model)
     */
    async getStaffDetails(staffId) {
        const response = await axios.get(`/api/staff/${staffId}`);
        return response.data;
    }
}

export default new StaffService();
